module.exports = "/assets/delivery/poczta-polska.png?lJsMfuL";